import Vue from 'vue'
import Vuex from 'vuex'
import CMS from './components/cms'
import Ayudas from './components/Ayudas'
import Sesion from './components/sesion'
import Blog from './components/Blog'
import Etiquetas from './components/Etiquetas'
import Imagenes from './components/Imagenes'
import Contacto from './components/Contacto'
import Mensaje from './components/Mensaje'

Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    Ayudas,
    CMS,
    Sesion,
    Blog,
    Etiquetas,
    Imagenes,
    Contacto,
    Mensaje,
  }
})
